import { render, staticRenderFns } from "./FriendDetail.vue?vue&type=template&id=2966dc60&scoped=true"
import script from "./FriendDetail.vue?vue&type=script&lang=js"
export * from "./FriendDetail.vue?vue&type=script&lang=js"
import style0 from "./FriendDetail.vue?vue&type=style&index=0&id=2966dc60&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2966dc60",
  null
  
)

export default component.exports